import { useState } from 'react'

import { FiRefreshCw, FiX } from 'react-icons/fi'

import { useUpdateAvailable } from '@/hooks'

/**
 * Offers a reload when a newer client build has been deployed.
 *
 * Deliberately a prompt rather than an automatic reload: someone may be part-way through
 * configuring an insight, and reloading under them would throw that away. Dismissible for the
 * same reason — the next focus check will raise it again on the following deploy.
 */
export const UpdateBanner = () => {
  const updateAvailable = useUpdateAvailable()
  const [dismissed, setDismissed] = useState(false)

  if (!updateAvailable || dismissed) return null

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2 flex items-center gap-3 rounded-box bg-primary text-primary-content shadow-lg px-4 py-2"
      data-testid="update-banner"
    >
      <span className="text-sm">A new version of Insights is available.</span>
      <button
        className="btn btn-sm btn-ghost text-primary-content"
        onClick={() => window.location.reload()}
        data-testid="update-banner-reload"
      >
        <FiRefreshCw className="w-4 h-4 mr-1" />
        Reload
      </button>
      <button
        className="btn btn-sm btn-ghost btn-square text-primary-content"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        data-testid="update-banner-dismiss"
      >
        <FiX className="w-4 h-4" />
      </button>
    </div>
  )
}

export default UpdateBanner
